import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        highlight:
          "relative bg-purple-100 dark:bg-purple-500/10 text-purple-600 dark:text-purple-400 hover:opacity-90 transition-all border border-purple-300 dark:border-purple-500/40 [text-shadow:0_0_10px_hsl(270_70%_60%_/_0.5)] [box-shadow:0_0_20px_hsl(270_70%_60%_/_0.3)] before:absolute before:-inset-0.5 before:bg-purple-500/20 before:rounded-full before:blur-[8px] before:-z-10",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
